import OnTheWayBack from './OnTheWayBack';

function App() {
  return <OnTheWayBack />;
}

export default App;